import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectorService {

  constructor() { }



  isMobile(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    // Mobile device detection using user agent
    return /android|iphone|ipad|ipod|blackberry|windows phone|opera mini|iemobile/i.test(userAgent);
  }

  isDesktop(): boolean {
    return !this.isMobile();
  }

  isTablet(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    return /ipad|tablet|kindle/i.test(userAgent);
  }

  getScreenWidth(): number {
    return window.innerWidth;
  }


}
